import { render, staticRenderFns } from "./VaimoContentLayer.vue?vue&type=template&id=1ea11110&scoped=true&"
import script from "./VaimoContentLayer.vue?vue&type=script&lang=ts&"
export * from "./VaimoContentLayer.vue?vue&type=script&lang=ts&"
import style0 from "./VaimoContentLayer.vue?vue&type=style&index=0&id=1ea11110&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ea11110",
  null
  
)

export default component.exports